import { createModel } from '@rematch/core';

import { RootModel } from '../index';

export default createModel<RootModel>()({
  state: {
    message: '',
    display: false,
    type: 'error',
    key: 0
  },

  reducers: {
    setToast(state, payload: { display?: boolean, type?: string, message: string }) {
      return {
        ...state,
        display: payload.display || true,
        type: payload.type || state.type,
        message: payload.message,
        key: new Date().getTime()
      };
    },

    setDisplay(state, display: boolean) {
      return { ...state, display: display || !state.display };
    }
  },

  effects: (dispatch) => ({
    showToast(payload: { display?: boolean, type?: string, message: string }): void {
      dispatch.toast.setToast(payload);
    },

    changeDisplay(payload: boolean): void {
      dispatch.toast.setDisplay(payload);
    }
  })
});
